import { useSelector } from 'react-redux'
import { SlideHeader } from './SlideHeader'
import { useDispatch } from 'react-redux'
import { setCourseGroupReportType } from 'store/CustomReports/actions'
import { useEffect } from 'react'
import { wait } from 'utils/helpers'
import { setContinueDisabled } from 'store/CustomReports/actions'
import ReportTypes from './ReportTypes'
import { setSingleCourseGroup } from 'store/CustomReports/actions'
import { resetMultipleCourseGroups } from 'store/CustomReports/actions'

function CourseGroupReportType() {
  const dispatch = useDispatch()

  const {
    courseGroupReportTypes,
    selectedCourseGroupReportType,
    editingReport,
  } = useSelector((store) => store.customReports)

  useEffect(() => {
    if (!editingReport) {
      dispatch(setSingleCourseGroup(null))
      dispatch(resetMultipleCourseGroups())
    }
  }, [editingReport, dispatch])

  useEffect(() => {
    wait(() => {
      if (selectedCourseGroupReportType !== null) {
        dispatch(setContinueDisabled(false, 2))
      }
    })
  }, [dispatch, selectedCourseGroupReportType])

  const handleClick = (type) => {
    dispatch(setCourseGroupReportType(type))
  }

  return (
    <>
      <SlideHeader header='Select Your Course Group Report Type' />
      <ReportTypes
        types={courseGroupReportTypes}
        selectedType={selectedCourseGroupReportType}
        fn={handleClick}
      />
    </>
  )
}

export default CourseGroupReportType
